module.exports = __webpack_public_path__ + "media/images/new/icons/purse-cdcc1acbb652a3103004f9211e70cce0.png";